import React from 'react';
import Typography from '@material-ui/core/Typography';

export default function CustomTypography({ children, ...props }) {
  return (
    <Typography
      align="center"
      color="textSecondary"
      variant="body2"
      {...props}
    >{children}</Typography>
  );
};
